import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import styles from "./styles.scss";

function Status({ status }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.status} style={{ borderColor: status.color }}>
      <p className={styles.label} style={{ color: status.color }}>
        {t(`taskStatuses.${status.label}`, status.label)}{" "}
        {(!!status.percentComplete || status.percentComplete === 0) && (
          <span className={styles.completion} style={{ color: status.color }}>
            {status.percentComplete}%
          </span>
        )}
      </p>
    </div>
  );
}

export { Status };
